import { render, staticRenderFns } from "./vbdatapickerrci.vue?vue&type=template&id=15c1d6de&scoped=true&"
import script from "./vbdatapickerrci.vue?vue&type=script&lang=js&"
export * from "./vbdatapickerrci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1d6de",
  null
  
)

export default component.exports